import { render, staticRenderFns } from "./OsdiMultilineTextField.vue?vue&type=template&id=62a58057&scoped=true&"
import script from "./OsdiMultilineTextField.vue?vue&type=script&lang=ts&"
export * from "./OsdiMultilineTextField.vue?vue&type=script&lang=ts&"
import style0 from "./OsdiMultilineTextField.vue?vue&type=style&index=0&id=62a58057&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a58057",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
